import { get } from "lodash";
import Loading from "shared/components/Spin";
import { useQuery } from "shared/hooks/useApi";
import { COVERAGE_CATEGORIES } from "utils/api/graphql/queries/coverage-categories";
import View from "./View";

const CollectionNeeds = ({ project, onNext, onBack }) => {
  const next = (fields) => {
    const values = Object.values(get(fields, "needs", {}));
    const selectedLevel = Math.round(
      values.reduce((sum, val) => sum + val, 0) / values.length,
    );
    onNext({
      payload: {
        fields: {
          ...fields,
          selectedLevel,
        },
      },
    });
  };
  const { data, loading } = useQuery(COVERAGE_CATEGORIES, {
    variables: { gt: { weight: 0 } },
  });

  if (loading) return <Loading />;

  return (
    <View
      data={get(data, "coverageCategories.data") || []}
      next={next}
      project={project}
      onBack={onBack}
    />
  );
};

export default CollectionNeeds;
